var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-3",attrs:{"no-body":""}},[_c('GameCardImageLink',{attrs:{"identifier":_vm.identifier}},[(_vm.cover_url)?_vm._t("default"):_c('GameImagePlaceholder')],2),_c('GameCardBody',{attrs:{"game_info":_vm.game_info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }